import { createSelector } from "reselect"

// selectors
import { selectHasMultipleLedgerSettings, selectIsLoadingLedgerSettings } from "shared/pac/selectors"

import { selectPacListViewPaintings } from "app/static/frontend/pac/selectors/pac-selectors"

// constants
import { pacPaths } from "app/static/frontend/imports/desktopPaths"

const selectQuicklink = (_, props) => props.widget.meta.quicklink

export const selectQuicklinkType = createSelector(selectQuicklink, (quicklink) => quicklink.type)

export const selectQuicklinkText = createSelector(selectQuicklink, selectQuicklinkType, (quicklink, type) => {
    if (!type) {
        return "Pick a Quicklink"
    }

    const val =
        type === DjangIO.app.widgets.types.QuicklinkType.custom.value
            ? quicklink.text || ""
            : DjangIO.app.widgets.types.QuicklinkType.by_value(type).label

    return val
})

export const selectQuicklinkUrl = createSelector(
    selectQuicklink,
    selectQuicklinkType,
    // QuicklinkType.new_receipt
    // QuicklinkType.new_disbursement
    selectHasMultipleLedgerSettings,
    selectIsLoadingLedgerSettings,
    selectPacListViewPaintings,
    (quicklink, type, hasMultipleLedgerSettings, isLoadingLedgerSettings, pacListViewPaintings) => {
        if (!type || !quicklink) {
            return ""
        }

        if (
            [
                DjangIO.app.widgets.types.QuicklinkType.new_receipt.value,
                DjangIO.app.widgets.types.QuicklinkType.new_disbursement.value,
            ].includes(type)
        ) {
            if (
                !isLoadingLedgerSettings &&
                !hasMultipleLedgerSettings &&
                pacListViewPaintings &&
                pacListViewPaintings.length
            ) {
                return DjangIO.app.widgets.types.QuicklinkType.by_value(type).url.replace(
                    pacPaths._pacDetailHome,
                    pacListViewPaintings[0].segueLink
                )
            }
        }

        return type === DjangIO.app.widgets.types.QuicklinkType.custom.value
            ? quicklink.url || ""
            : DjangIO.app.widgets.types.QuicklinkType.by_value(type).url
    }
)

export const selectQuicklinkIsExternal = createSelector(
    selectQuicklinkUrl,
    selectQuicklinkType,
    (_, props) => props.isExternal,
    // TODO: make this not poo
    (url, type, isExternal) =>
        isExternal ||
        (type === DjangIO.app.widgets.types.QuicklinkType.custom.value &&
            url &&
            (url.includes("quorum.us/campaign/") ||
                !url.includes("quorum.us") ||
                url.includes("external") ||
                // if its a pdf, such as q case studies
                url.slice(-5).includes(".pdf")))
)
